import React, { useEffect, useRef } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper-bundle.min.css"
import "swiper/swiper.min.css"

const Slider = ({ videos, selectIndex, index }) => {
  const swiperRef = useRef(null)

  const handleSlideChange = (e) => {
    const newIndex = e.realIndex
    if (newIndex !== index) {
      selectIndex(newIndex)
    }
  }

  useEffect(() => {
    if (swiperRef.current?.swiper.realIndex !== index) {
      swiperRef.current?.swiper.slideTo(index + 1)
    }
  }, [index])

  return (
    <div style={{ width: "100vw" }}>
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        onSlideChange={handleSlideChange}
        ref={swiperRef}
        centeredSlides
      >
        {videos.map((v, i) => (
          <SwiperSlide key={i}>
            <div
              style={{
                width: "calc(100vw - 40px)",
                margin: "0 20px",
                height: "calc(100vw * 0.74)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {v.video.includes(".mp4") ? (
                <video muted autoPlay loop playsInline>
                  <source src={v.video} type="video/mp4" />
                </video>
              ) : (
                <img src={v.video} style={{ marginBottom: 0 }} />
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default Slider
